import { getWindowLocation } from './getWindowLocation';

export const getQueryParam = (param: string, searchString?: string): string | null => {
  const location = getWindowLocation();

  searchString = searchString || location?.search;

  if (!searchString) return null;

  const urlParams = new URLSearchParams(searchString);

  return urlParams.get(param);
};

export const getQueryParams = (searchString?: string): URLSearchParams => {
  const location = getWindowLocation();

  searchString = searchString || location?.search;

  if (!searchString) return new URLSearchParams();

  return new URLSearchParams(searchString);
};
